'use client'

import { isNil } from 'lodash-es'
import { ReadonlyURLSearchParams } from 'next/navigation'
import { useState } from 'react'

import { DateRange, parseDate, today } from '@/shared/lib'

export const DATE_FORMAT = 'yyyy-MM-dd'

export const defaultPeriod = {
  from: today,
  to: undefined,
}

export const getDefaultPeriod = (
  searchParams: ReadonlyURLSearchParams | null,
) => {
  const startDate = searchParams?.get('startDate')
  const endDate = searchParams?.get('endDate')

  if (isNil(startDate) || isNil(endDate)) {
    return defaultPeriod
  }

  return {
    from: parseDate({ value: startDate, format: DATE_FORMAT }),
    to: parseDate({ value: endDate, format: DATE_FORMAT }),
  }
}

type Props = {
  defaultPeriod?: DateRange
}

export const useContractPeriod = ({
  defaultPeriod: defaultPeriodProp,
}: Props = {}) => {
  const [period, setPeriod] = useState<DateRange>(
    defaultPeriodProp || defaultPeriod,
  )

  const hasPeriodSelected = !isNil(period.from) && !isNil(period.to)

  const updatePeriod = (dateRange: DateRange) => {
    setPeriod({
      from: dateRange.from,
      to: dateRange.to,
    })
  }

  return {
    period,
    hasPeriodSelected,
    updatePeriod,
  }
}
